<template>
    <div class="l-ss-c-offer-params-wrapper">
        <div class="l-ss-c-offer-params-title">{{ title }}</div>
        <div class="l-ss-c-offer-params-items">
            <div
                class="l-ss-c-offer-params-item"
                :class="{
                    'l-ss-c-offer-params-item-active': item === value,
                    'l-ss-c-offer-params-item-disabled': item !== value && !availableItems.includes(item)
                }"
                v-for="(item, i) in items"
                :key="i"
                @click.prevent.stop="changeParam(item)">
                {{ item }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
            },
            title: {
                type: String,
            },
            items: {
                type: Array,
            },
            availableItems: {
                type: Array,
                default: () => [],
            },
        },
        setup(props, { emit }) {
            const changeParam = (param) => {
                emit('input', param);
                emit('change', param);
            };

            return {
                changeParam,
            };
        },
    };
</script>

<style scoped>

</style>
